import { Link } from "react-router-dom";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";

interface NavlinksComponentProps {
  links: { href: string; text: string; activeLink: string }[];
}

function NavlinksComponent({ links }: NavlinksComponentProps) {
  return (
    <NavigationMenu className="hidden md:flex">
      <NavigationMenuList>
        <NavigationMenuItem className="flex gap-4">
          {
            links.map((link) => (
              <Link key={link.href} to={link.href} data-cy={`nav-link-${link.href.replace(/\//g, "")}`}>
                <span className={`
                  text-sm hover:text-black
                  ${location.pathname.includes(link.activeLink) ? "text-black" : "text-gray-500"}
                `}>
                  {link.text}
                </span>
              </Link>
            ))
          }
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu >
  );
}

export default NavlinksComponent;
